import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './index.module.css';

const HomeContentBlock = ({ content = {} }) => {
  const {
    title            = 'For Businesses',
    bodyHtml,
    imagePath,
    imageAltText     = '',
    sideImagePath,
    sideImageAltText = '',
    callToActionText = 'Enquire now',
    callToActionLink = '/business-plates',
  } = content;

  return (
    <section className="home-content-block">
      <div className="home-content-block__main">
        <h2 className="home-content-block__title">{title}</h2>
        {bodyHtml && (
          <div
            className="home-content-block__text"
            dangerouslySetInnerHTML={{ __html: bodyHtml }}
          />
        )}
        {imagePath && (
          <img
            className="home-content-block__image home-content-block__image--main"
            src={imagePath}
            alt={imageAltText}
            width="572"
            height="544"
          />
        )}
        <Link className="home-content-block__cta" to={callToActionLink}>
          {callToActionText}
        </Link>
      </div>
      <div className="home-content-block__side">
        {sideImagePath && (
          <img
            className="home-content-block__image home-content-block__image--side"
            src={sideImagePath}
            alt={sideImageAltText}
            width="572"
            height="544"
          />
        )}
      </div>
    </section>
  );
};

HomeContentBlock.propTypes = {
  content: PropTypes.shape({
    title:            PropTypes.string,
    bodyHtml:         PropTypes.string,
    imagePath:        PropTypes.string,
    imageAltText:     PropTypes.string,
    sideImagePath:    PropTypes.string,
    sideImageAltText: PropTypes.string,
    callToActionText: PropTypes.string,
    callToActionLink: PropTypes.string,
  }),
};

export default HomeContentBlock;
